import { useTheme } from '@mui/material/styles';

export default function RequiredAsterisk() {
    const theme = useTheme();
    return <span style={{ color: theme.palette.error.E_750, marginRight: '2px' }}>*</span>;
}
